export default __webpack_public_path__ + "static/media/fab2.804ac0ed.jpg";